import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { UserSubscriptionType } from '../../services/subscriptions/subscriptions.types';
import { type RoomForPatient } from '../../services/room';

const getInitialState = (): RoomForPatient => ({
  id: '0',
  legacyId: 0,
  isPersonal: false,
  sharedRoomDisplayName: '',
  slug: '',
  owner: {
    id: '0',
    title: '',
    firstName: '',
    lastName: '',
    displayName: '',
    userProfilePictureUrl: '',
    subscriptionType: UserSubscriptionType.Free,
  },
  shouldRedirect: false,
  redirectUrl: '',
  isPasscodeEnabled: false,
  providerEntitlements: null,
});

export const waitingRoomSlice = createSlice({
  name: 'waitingRoom',
  initialState: getInitialState(),
  reducers: {
    setWaitingRoom: (state, action: PayloadAction<RoomForPatient | null>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setWaitingRoom } = waitingRoomSlice.actions;
